import React from 'react';
import imageIcon from '../../assets/icons/signage-plus/image-icon.svg';
import canvaIcon from '../../assets/icons/signage-plus/canva-icon.png';
import canvaFile from '../../assets/icons/signage-plus/canva-file.svg';
import folder from '../../assets/icons/signage-plus/canva-folder.svg';
import { useIntl, FormattedMessage } from 'react-intl';

function CanvaAccordion({ tabData, onDragStart, isPlaylistDetail, isCanvaAuthenticated, canvaUrl, handleCanvaSignOut}) {
  const intl = useIntl(); 
  const renderItems = (items, isChild = false) => {
  if (!isChild) {
    const recentDesignsItems = items.filter((item) => item.type !== 'folder');

    if (recentDesignsItems.length > 0) {
      const recentDesignsFolder = {
        id: 'recent-designs',
        name: intl.formatMessage({ id: 'RECENT_DESIGNS' }),
        type: 'folder',
        items: recentDesignsItems,
      };
      items = items.filter((item) => item.type === 'folder');
      items.unshift(recentDesignsFolder);
    }
  }

  return (
    items &&
    items.length > 0 &&
    items.map((item) => {
      if (item.type === 'folder') {
        item = item.folder || item;
        return (
          <div
            className={`accordion-item canvaAccordion`}
            key={item.id}
          >
            <h2 className="accordion-header" id={`panelsStayOpen-heading${item.id}`}>
              <button
                className={`accordion-button playlist-accordion-title list-group-item collapsed`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#panelsStayOpen-collapse${item.id}`}
                aria-expanded="false"
                aria-controls={`panelsStayOpen-collapse${item.id}`}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <span className="accordion-arrow me-2"></span>
                <img src={folder} alt="" className="icon icon-24 me-3 ms-2" />
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    width: 'calc(100% - 70px)',
                  }}
                  title={item.name || item.title || <FormattedMessage id="UNTITLED_DESIGN" />}
                >
                  {item.name || item.title || <FormattedMessage id="UNTITLED_DESIGN" />}
                </span>
              </button>
            </h2>
            <div
              id={`panelsStayOpen-collapse${item.id}`}
              className={`accordion-collapse collapse`}
              aria-labelledby={`panelsStayOpen-heading${item.id}`}
            >
              <div className="accordion-body">
                {item.items && renderItems(item.items, true)}
              </div>
            </div>
          </div>
        );
      } else {
        if (item.type === 'design') {
          item = item.design;
        }
        if (item.type === 'image') {
          item = item.image;
        }
        return (
          <div
            key={item.id}
            className="media-content-row playlist-accordion-title d-flex align-items-center"
            draggable={isPlaylistDetail}
            onDragStart={() =>
              onDragStart &&
              onDragStart(
                {
                  name: item.name || item.title || intl.formatMessage({ id: 'UNTITLED_DESIGN' }),
                  id: item.id,
                  duration: item.duration,
                  updatedAt: item.updated_at,
                  subcategory: 'canva',
                  category: 'canva',
                  page_count: item.page_count || 0,
                },
                'canva',
              )
            }
            style={{ cursor: onDragStart ? 'grab' : 'default', height:'53px' }}
          >
            <img src={canvaFile} alt="" className="icon icon-24 me-3 ms-1" />
            <span
              className="ms-2"
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: 'calc(100% - 50px)',
              }}
              title={
                (item.name || item.title || intl.formatMessage({ id: 'UNTITLED_DESIGN' })) +
                ' (' + new Date(item.updated_at * 1000).toLocaleString() + ')'
              }
            >
              {item.name || item.title || <FormattedMessage id="UNTITLED_DESIGN" />}{' (' + new Date(item.updated_at * 1000).toLocaleString() + ')'}
            </span>
          </div>
        );
      }
    })
  );
};

  return isCanvaAuthenticated ? (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%',
      textAlign: 'center'
    }}>
      <div style={{
        textAlign: 'left', 
        flex: 1, 
        overflowY: 'auto',
        paddingBottom: '10px'
      }} className="accordion accordion-body-scroll" id="accordionPanelsStayOpenExample">
        {renderItems(tabData)}
      </div>
      <div style={{
        paddingTop: '10px',
        paddingBottom: '10px',
        borderTop: '1px solid #dee2e6',
        backgroundColor: 'white'
      }}>
        <button
          className="btn-canva-bg d-flex align-items-center justify-content-center"
          style={{ paddingLeft: 20, paddingRight: 20, margin: 'auto'}}
          onClick={handleCanvaSignOut}
        >
          <img src={canvaIcon} alt="" className="icon icon-24 me-2" />
          <FormattedMessage id="SIGNOUT_FROM_CANVA" />
        </button>
      </div>
    </div>
  ) : (
    <div
      className="d-flex flex-column align-items-center justify-content-center w-100"
      style={{ height: '100%' }}
    >
      <button
        className="btn-canva-bg d-flex align-items-center justify-content-center"
        style={{ paddingLeft: 20, paddingRight: 20 }}
        onClick={() => {
          console.log(canvaUrl);
          window.location.href = canvaUrl;
        }}
      >
        <img src={canvaIcon} alt="" className="icon icon-24 me-2" />
        <FormattedMessage id="CONNECT_WITH_CANVA" />
      </button>	  
    </div>
  );
}

export default CanvaAccordion;
